//---------------------------------------------------
//  Nom du fichier : SignIn.js 
//
//  Description: Component qui gère la création de compte d'un utilisateur
//               Gère aussi la vérification par email
//
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------

import React, {useState, useEffect} from 'react';
import './SignIn.css';
import './Login.css';
import Background from './background';
import {callAPI} from './callAPI.js'

import { useTranslation } from 'react-i18next';

function VerificationCode({ setValidEverythingProceed, email}) {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [invalidCode, setInvalidCode] = useState(false)
  function handleSubmit(e) {
    e.preventDefault();

    setTimeout(() => {
      const formVerif = new FormData()
      formVerif.append('type', 'verif_email')
      formVerif.append('code', code)

      callAPI("read", formVerif)
      .then((codeVerif) => {
        if(codeVerif.result){
          setValidEverythingProceed(true)
        }
        else {
          setInvalidCode(true)
        }
      })
    },200)
  }

  const handleChange = (e) => {
    const value = e.target.value;

    // Autoriser seulement les chiffres et max 6 caractères
    if (/^\d{0,6}$/.test(value)) {
      setCode(value);
    }
  };


  return (
    <div className='SignIn' id="vericode">
      <form className='formOfLogin' id='formVericode' method='post' onSubmit={handleSubmit}>
        <h1 className='titleLogin' id='titleVericode'>{t('register_verif_title')} {email}</h1>
        {invalidCode && <div id="erreurVericode" className='wrongInput'>{t('register_verif_wrong')}</div>}
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          value={code}
          onChange={handleChange}
          placeholder="Entrez le code"
          className="inputVericode"
        />
        <button id='btSignIn' className='btLogin' type="submit"></button>
      </form>
    </div>
  );
}

function SignIn({setLoggedIn, setGradeType, openSignIn, setImagePath, connectWebSocket}) {

  const [wrongUsername, setWrongUsername] = useState(false)
  const [wrongEmail, setWrongEmail] = useState(false)
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [invalidPassword, setInvalidPassword] = useState(false);

  const { t } = useTranslation();


  function handleSubmit(e) {
    // Prevent the browser from reloading the page
    e.preventDefault();
    setWrongEmail(false)
    setWrongUsername(false)
    setInvalidPassword(false);

    const usernameRegex = /^[a-zA-Z0-9_-]{3,20}$/;
    if (!usernameRegex.test(username)) {
      setWrongUsername(true);
      return;
    }

    const passwordRegex = /^\S{8,}$/;
    if (!passwordRegex.test(password)) {
      setInvalidPassword(true);
      return;
    }

    setTimeout(() => {
      const formVerif = new FormData()
      formVerif.append('type', 'check_existing_user')
      formVerif.append('email', email)
      formVerif.append('username', username)

      callAPI("read", formVerif)
      .then((dataVerif) => {
        if(dataVerif.result["username_exists"] || dataVerif.result["email_exists"]){
          if(dataVerif.result["username_exists"]){
            setWrongUsername(true)
          }
          if(dataVerif.result["email_exists"]){
            setWrongEmail(true)
          }
        }
        else {
          const formEmail = new FormData()
          formEmail.append('type', 'send_email')
          formEmail.append('email', email)

          callAPI("write", formEmail)
          .then((dataEmail) => {
            if(!dataEmail.status.includes('Error')){
              setVericodeSection(true)
            }
            else {
              setInvalidEmail(true)
            }
          })
        }
      })
    },200)
  }

  const [name, setName] = useState('');
  const [firstname, setFirstname] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [visibleOrNot, setVisibleOrNot] = useState("password");
  const [vericodeSection, setVericodeSection] = useState(false);
  const [validEverythingProceed, setValidEverythingProceed] = useState(false);

  useEffect(() => {
    if(validEverythingProceed == true){
      const form = new FormData()
      form.append('type', 'createUser')
      form.append('name', name)
      form.append('firstname', firstname)
      form.append('username', username)
      form.append('email', email)
      form.append('password', password)

      callAPI("write", form, true)
      .then((dataCreate) => {
        if(!dataCreate.status.includes('Error')){
          setLoggedIn(true)
          setGradeType(dataCreate.grade_type)
          setImagePath(dataCreate.imagePath)
          localStorage.setItem("user_id", dataCreate.user_id)
          localStorage.setItem("role", dataCreate.role)
          connectWebSocket()
        }
        else {
          if(dataCreate.status.includes("users.username")){
            setWrongUsername(true)
          }
          if(dataCreate.status.includes("users.email")){
            setWrongEmail(true)
          }
        }
      })
      .catch((error) => {
          console.error("API call failed:", error);
      });
    }
  }, [validEverythingProceed]);

  return (
    <div>
      <Background func={() => {openSignIn(false)}}>
        <div className='SignIn'>
          <form className='formOfLogin' method='post' onSubmit={handleSubmit}>
                <h1 id='titleSignIn' className='titleLogin'>{t('register_title')}</h1>
                {wrongEmail && <div className='wrongInput'>{t('register_email_exists')}</div>}
                {wrongUsername && <div className='wrongInput'>{t('register_invalid_username_1')} <div>{t('register_invalid_username_2')}</div></div>}
                {invalidEmail && <div className='wrongInput'>{t('register_invalid_email')}</div>}
                {invalidPassword && <div className='wrongInput'>{t('register_invalid_password_l')}<div>{t('register_invalid_password_2')}</div></div>}
                <label className='SignIn_container'>
                  <p className='champ'>{t('register_lastname')}</p>
                  <input 
                    className='inputLogin'
                    required 
                    name="name" 
                    value={name}
                    maxLength={50}
                    onChange={e => setName(e.target.value)}/>
                </label>
                <label className='SignIn_container'>
                  <p className='champ'>{t('register_name')}</p>
                  <input 
                    className='inputLogin'
                    required 
                    name="firstname" 
                    value={firstname}
                    maxLength={50}
                    onChange={e => setFirstname(e.target.value)}/>
                </label>
                <label className='SignIn_container'>
                  <p className='champ'>{t('username')}</p>
                  <input 
                    className='inputLogin'
                    required 
                    name="username"
                    autoComplete="username" 
                    maxLength={20}
                    value={username}
                    onChange={e => setUsername(e.target.value)}/>
                </label>
                <label className='SignIn_container'>
                  <p className='champ'>{t('register_email')}</p>
                  <input 
                    className='inputLogin'
                    required 
                    name="email" 
                    value={email}
                    type='email'
                    maxLength={255}
                    onChange={e => setEmail(e.target.value)}/>
                </label>
                <label className='SignIn_container'>
                  <p className='champ'>{t('password')}</p>
                  <input 
                    className='inputLogin'
                    required 
                    type={visibleOrNot}
                    autoComplete="new-password"
                    name="password" 
                    value={password}
                    onChange={e => setPassword(e.target.value)}/>
                    <span 
                      className="material-symbols-outlined oeil" 
                      onClick={() => {
                        if (visibleOrNot === "password") {
                          setVisibleOrNot("text");
                        } else {
                          setVisibleOrNot("password");
                        }
                      }} 
                      style={{ cursor: 'pointer', textTransform: 'lowercase' }}
                    >
                      {visibleOrNot === "password" ? "visibility" : "visibility_off"}
                    </span>
                </label>
                <button id='btSignIn' className='btLogin' type="submit"></button>
            </form>
        </div>
        {vericodeSection && <VerificationCode setValidEverythingProceed={setValidEverythingProceed} email={email}/>}
        </Background>
    </div>
  );
}

export default SignIn;